import React from 'react';
import { filtrationSteps } from '../mock';
import { Wind, Droplets, Filter, Sparkles } from 'lucide-react';

const icons = [Wind, Droplets, Filter, Sparkles];

export default function HowItWorks() {
  return (
    <section id="how" className="relative py-24 bg-gradient-to-b from-sky-50/70 to-white overflow-hidden">
      <div className="bubble w-40 h-40 -top-10 left-10 opacity-40" />
      <div className="bubble w-24 h-24 bottom-20 right-20 opacity-40" style={{ animationDelay: '2s' }} />

      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="text-xs tracking-[0.3em] text-sky-600 font-semibold uppercase mb-3">How Upgrade Water Works</div>
            <h2 className="font-display text-4xl md:text-5xl font-semibold text-slate-900 leading-tight">
              A patented <span className="water-text">4-step process</span> from air to glass
            </h2>
            <p className="mt-5 text-slate-600 leading-relaxed">
              Our systems need nothing but ambient humidity above 40% — conditions found in almost every
              coastal, tropical or marine environment on earth. From the moment air enters the intake
              to the moment water is poured, each drop passes through four rigorously engineered stages.
            </p>

            <div className="mt-8 grid grid-cols-2 gap-4">
              <div className="p-5 rounded-2xl bg-white border border-sky-100">
                <div className="text-3xl font-display font-semibold text-slate-900">40%+</div>
                <div className="text-xs text-slate-500 mt-1">Min. humidity required</div>
              </div>
              <div className="p-5 rounded-2xl bg-white border border-sky-100">
                <div className="text-3xl font-display font-semibold text-slate-900">3000x</div>
                <div className="text-xs text-slate-500 mt-1">Ozone vs chlorine strength</div>
              </div>
              <div className="p-5 rounded-2xl bg-white border border-sky-100">
                <div className="text-3xl font-display font-semibold text-slate-900">&lt; 45 dB</div>
                <div className="text-xs text-slate-500 mt-1">Whisper-quiet operation</div>
              </div>
              <div className="p-5 rounded-2xl bg-white border border-sky-100">
                <div className="text-3xl font-display font-semibold text-slate-900">24/7</div>
                <div className="text-xs text-slate-500 mt-1">Continuous generation</div>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="absolute left-8 top-6 bottom-6 w-0.5 bg-gradient-to-b from-sky-300 via-cyan-400 to-teal-400" />
            <div className="space-y-6">
              {filtrationSteps.map((s, idx) => {
                const Icon = icons[idx];
                return (
                  <div key={s.step} className="relative pl-20">
                    <div className="absolute left-0 top-0 w-16 h-16 rounded-2xl bg-white border border-sky-200 shadow-lg shadow-sky-100 flex items-center justify-center">
                      <Icon className="w-6 h-6 text-sky-600" />
                    </div>
                    <div className="absolute left-6 -top-1 text-[10px] font-bold tracking-widest text-cyan-500">STEP {s.step}</div>
                    <div className="bg-white rounded-2xl p-5 border border-sky-100 shadow-sm hover:shadow-md transition-shadow">
                      <h4 className="font-display text-xl font-semibold text-slate-900">{s.title}</h4>
                      <p className="mt-2 text-sm text-slate-600 leading-relaxed">{s.description}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
